import { useEffect, useState } from 'react';

import type { InputProps } from '../type';

export type DecimalCounterInputProps = InputProps & {
  count: string;
  max: number;
  min: number;
  onCountChange?: (count: string) => void;
};

export function useDecimalCounterInput({
  count: value,
  max,
  min,
  onCountChange,
  className,
  ...rest
}: DecimalCounterInputProps) {
  const [state, setState] = useState({ count: value, inputValue: value.toString() });

  useEffect(() => {
    if (value !== state.count) {
      setState({ count: value, inputValue: value.toString() });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const decrement = () => {
    if (parseFloat(state.count) <= min) {
      return;
    }

    const newCount = parseFloat(state.count) - 1;
    setState({ count: newCount.toString(), inputValue: newCount.toString() });
    handleChangeCount(newCount);
  };

  const increment = () => {
    if (parseFloat(state.count) >= max) {
      return;
    }

    const newCount = parseFloat(state.count) + 1;

    setState({ count: newCount.toString(), inputValue: newCount.toString() });
    handleChangeCount(newCount);
  };

  const handleBlur = () => {
    let num = parseFloat(state.inputValue);
    num = num > max ? max : num;
    num = num < min ? min : num;

    if (Number.isNaN(num) === true) {
      setState({ count: state.count, inputValue: state.count.toString() });
    } else {
      setState({ count: num.toString(), inputValue: num.toString() });
      handleChangeCount(num);
    }
  };

  const handleChangeCount = (v: number) => {
    if (onCountChange !== undefined) {
      onCountChange(v.toString());
      return v;
    }
    return false;
  };

  const handleChangeInput = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setState((s) => ({ ...s, inputValue: target.value }));
  };

  return {
    inputValue: state.inputValue,
    min,
    decrement,
    increment,
    handleChangeInput,
    handleBlur,
    className,
    rest,
  };
}
